import type { Embodiment, EndEffector } from "@/api";
import { TableRow } from "@carbon6/c6-frontend-design";
import { formatEndEffector } from "./embodimentFormatters";

export type EmbodimentTableRowClickHandler = (row: EmbodimentTableRow) => void;

export class EmbodimentTableRow extends TableRow implements Embodiment {
  readonly uuid: string;
  readonly name: string;
  readonly description: string | null;
  readonly end_effector: EndEffector;
  readonly created_at: string;
  readonly modified_at: string;
  // 목록 컬럼 표시값. embodiment 부품에서 파생한다.
  readonly endEffectorName: string | null;
  private readonly rowClickHandler: EmbodimentTableRowClickHandler | null;

  constructor(
    embodiment: Embodiment,
    rowClickHandler: EmbodimentTableRowClickHandler | null = null,
  ) {
    super(null);
    this.rowClickHandler = rowClickHandler;
    this.uuid = embodiment.uuid;
    this.name = embodiment.name;
    this.description = embodiment.description;
    this.end_effector = embodiment.end_effector;
    this.created_at = embodiment.created_at;
    this.modified_at = embodiment.modified_at;
    this.endEffectorName = embodiment.end_effector?.name
      ? formatEndEffector(embodiment.end_effector)
      : null;
  }

  getRowId(): string {
    return this.uuid;
  }

  // 모든 행을 표시한다. 가시성은 서버 조회가 정한다.
  canShow(): boolean {
    return true;
  }

  // 선택 UI 가 없는 목록이므로 선택 대상이 아니다.
  canSelect(): boolean {
    return false;
  }

  get isRowClickable(): boolean {
    return this.rowClickHandler !== null;
  }

  onRowClick(): void {
    this.rowClickHandler?.(this);
  }
}

export function createEmbodimentTableRow(
  embodiment: Embodiment,
  rowClickHandler: EmbodimentTableRowClickHandler | null = null,
): EmbodimentTableRow {
  return new EmbodimentTableRow(embodiment, rowClickHandler);
}

export function createEmbodimentTableRows(
  embodiments: readonly Embodiment[],
  rowClickHandler: EmbodimentTableRowClickHandler | null = null,
): EmbodimentTableRow[] {
  return embodiments.map((embodiment) => createEmbodimentTableRow(embodiment, rowClickHandler));
}
